import React from 'react';
import { Link } from 'react-router-dom';
import {
  SUPPORT_EMAIL,
  UNSUB_LINK,
  SELFCARE_APP_NAME,
  CALL_CENTER_USSD,
  MANAGE_USSD,
  COMPANY_NAME,
  COMPANY_LOCATION,
} from '../../../common/constants';

function SiteFooter({ t, language, hideUnsubLink }) {
  return (
    <div className="site-footer">
      <div className="site-footer-grid">
        <div className="site-footer-col">
          <h5>{t('Поддержка', 'Колдоо', 'Support')}</h5>
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </div>

        <div className="site-footer-col">
          <h5>{t('Как отменить подписку', 'Жазылууну кантип жокко чыгарса болот', 'How to cancel your subscription')}</h5>
          <span>{t(`Личный кабинет: приложение ${SELFCARE_APP_NAME}`, `Жеке кабинет: ${SELFCARE_APP_NAME} колдонмосу`, `Self-service: the ${SELFCARE_APP_NAME} app`)}</span>
          <span>{t(`Звонок в контакт-центр: ${CALL_CENTER_USSD}`, `Байланыш борборуна чалуу: ${CALL_CENTER_USSD}`, `Call the contact center: ${CALL_CENTER_USSD}`)}</span>
          <span>{t(`Управление подпиской по USSD: ${MANAGE_USSD}`, `Жазылууну USSD аркылуу башкаруу: ${MANAGE_USSD}`, `Manage your subscription via USSD: ${MANAGE_USSD}`)}</span>
          {!hideUnsubLink && (
            <a href={UNSUB_LINK} target="_blank" rel="noopener noreferrer">{UNSUB_LINK.replace('https://', '')}</a>
          )}
        </div>

        <div className="site-footer-col">
          <h5>{t('Документы', 'Документтер', 'Documents')}</h5>
          <Link to={`/terms?lang=${language}`}>{t('Условия использования', 'Колдонуу шарттары', 'Terms of use')}</Link>
          <Link to={`/privacy?lang=${language}`}>{t('Политика конфиденциальности', 'Купуялуулук саясаты', 'Privacy policy')}</Link>
        </div>
      </div>

      <div className="site-footer-bottom">
        © {new Date().getFullYear()} {COMPANY_NAME}, {COMPANY_LOCATION}
      </div>
    </div>
  );
}

export default SiteFooter;
